<template>
  <div>
    <p class="title">已开通产品</p>
    <div class="open-product-wrapper">
      <div
        class="product-item"
        v-for="item in productList"
        :key="item.busi"
        @click="goProductDetail(item.busi)"
      >
        <div class="title">{{formatName(item.busi)}}</div>
        <div class="line"></div>
        <p class="info">
          <span class="name">开通时间</span>
          <span class="num">{{item.ctime}}</span>
        </p>
        <p class="info">
          <span class="name">截止时间</span>
          <span class="num">{{item.expire}}</span>
        </p>
        <p class="info" v-if="showQuota(item.busi)">
          <span class="name">授权配额</span>
          <span class="num">{{item.reqtotal}}</span>
        </p>
        <p class="info" v-if="showQuota(item.busi)">
          <span class="name">剩余配额</span>
          <span class="num">{{parseInt(item.reqtotal) - parseInt(item.reqused)}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const REMOVED_PRODUCT_CODES = [
  'blackip_online',
  'blackip_offline',
  'blackipv3_online',
  'blackipv3_offline',
  'blackdevice_online',
  'blackdevice_offline',
  'black_device_online',
  'black_device_offline'
]

export default {
  props: {
    product: {
      type: Array
    }
  },
  computed: {
    productList () {
      return this.product.filter((item) => {
        return !REMOVED_PRODUCT_CODES.includes(item.busi) && item.auditflag === '5'
      })
    }
  },
  methods: {
    formatName (busi) {
      switch (busi) {
        case 'antifraud_online':
          return '移动风险感知平台-在线API版本'
        case 'antifraud_offline':
          return '移动风险感知平台-私有化版本'
        case 'heika_online':
          return '手机号画像-在线API版本'
        case 'heika_offline':
          return '手机号画像-私有化版本'
        case 'heika_without_mainland_offline':
          return '境外手机号画像-私有化版本'
        case 'group_receive_code_online':
          return '手机号攻击情报-在线请求'
        case 'group_receive_code':
          return '手机号攻击情报-离线版本'
        case 'bank_card_all_offline':
          return '银行卡画像'
        case 'company_account_offline':
          return '对公账号'
        case 'merchant_online':
          return '洗钱商户'
        case 'fraud_victim_payments_online':
          return '受害人涉诈支付'
        case 'digital_rmb_offline':
          return '数字人民币画像'
        case 'black_mailbox_online':
          return '邮箱画像-在线API版本'
        case 'black_mailbox_offline':
          return '邮箱画像-私有化版本'
        case 'blackipv2_online':
          return 'IP画像-在线API版本'
        case 'blackipv2_offline':
          return 'IP画像-私有化版本'
      }
    },
    showQuota (busi) {
      return busi !== 'group_receive_code' && busi.indexOf('offline') === -1
    },
    goProductDetail (busi) {
      switch (busi) {
        case 'antifraud_online':
          this.$router.push({
            name: 'riskMobile',
            params: {
              busi: 'antifraud_online'
            }
          })
          break
        case 'antifraud_offline':
          this.$router.push({
            name: 'riskMobile',
            params: {
              busi: 'antifraud_offline'
            }
          })
          break
        case 'heika_online':
          this.$router.push({
            name: 'riskPhone',
            params: {
              busi: 'heika_online'
            }
          })
          break
        case 'heika_offline':
          this.$router.push({
            name: 'riskPhone',
            params: {
              busi: 'heika_offline'
            }
          })
          break
        case 'heika_without_mainland_offline':
          this.$router.push({
            name: 'riskPhone',
            params: {
              busi: 'heika_without_mainland_offline'
            }
          })
          break
        case 'group_receive_code_online':
        case 'group_receive_code':
          this.$router.push({
            name: 'riskPhoneAttackMonitor',
            params: { busi }
          })
          break
        case 'bank_card_all_offline':
        case 'company_account_offline':
        case 'merchant_online':
        case 'fraud_victim_payments_online':
        case 'digital_rmb_offline':
          this.$router.push({
            name: 'financialAntiFraud',
            params: { busi }
          })
          break
        case 'black_mailbox_online':
        case 'black_mailbox_offline':
          this.$router.push({
            name: 'riskMailbox',
            params: { busi }
          })
          break
        case 'blackipv2_online':
          this.$router.push({
            name: 'riskIp',
            params: {
              busi: 'blackipv2_online'
            }
          })
          break
        case 'blackipv2_offline':
          this.$router.push({
            name: 'riskIp',
            params: {
              busi: 'blackipv2_offline'
            }
          })
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(29, 36, 60, 1);
  line-height: 30px;
  margin-bottom: 10px;
}
.open-product-wrapper {
  display: flex;
  flex-wrap: wrap;
  .product-item {
    width: 268px;
    height: 268px;
    margin-right: 38px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(244, 249, 255, 1) 100%
    );
    box-shadow: 4px 4px 8px 0px rgba(6, 22, 53, 0.06);
    border-radius: 4px;
    padding: 20px 18px 0 18px;
    margin-bottom: 32px;
    box-sizing: border-box;
    cursor: pointer;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: rgba(29, 36, 60, 1);
      line-height: 24px;
      margin-bottom: 12px;
    }
    .line {
      height: 2px;
      background: linear-gradient(
        270deg,
        rgba(176, 251, 255, 1) 0%,
        rgba(41, 108, 255, 1) 100%
      );
      margin-bottom: 32px;
    }
    .info {
      display: flex;
      margin-bottom: 12px;
      .name {
        font-size: 14px;
        font-weight: 500;
        color: rgba(29, 36, 60, 1);
        line-height: 24px;
        margin-right: 28px;
      }
      .num {
        font-size: 14px;
        font-weight: 400;
        color: rgba(29, 36, 60, 1);
        line-height: 24px;
      }
    }
  }
}
</style>
